import React from 'react';
import moment from 'moment';
import { FullStar } from '../../assets/images';
import { commaingNumber } from '../../utils';

class OverallManager {
  constructor(data) {
    this.data = data;
    this.contracts = this.data[4]
    this.overall = this.data[0].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallAvgWaitTime = this.data[1].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallRepeatUsers = this.data[2].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallRatings = this.data[3].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallData = this.getOverallData();
    this.ratingsData = this.getOverallRatingsData();
    this.avgWaitTimeData = this.getOverallAvgWaitTimeData();
    this.repeatUsersData = this.getOverallRepeatUsersData();
  }

  checkPreviousYear = (endDate) => {
    const endYear = moment(endDate).format('YYYY');
    const currentYear = moment(new Date()).format('YYYY');
    if (parseInt(currentYear, 10) - parseInt(endYear, 10) === 1) {
      return true;
    }
    return false;
  };

  apiResponse = () => {
    return this.data;
  };

  getStartAndEndDate = (start_date, end_date, labels) => {
    let startDate = moment(start_date).format('YY/MMM').split('/').reverse().join(' ');
    let endDate = moment(end_date).format('YY/MMM').split('/').reverse().join(' ');

    start_date = Date.parse(start_date);
    end_date = Date.parse(end_date);
    const currentDate = Date.parse(new Date());
    if (currentDate >= start_date && currentDate <= end_date && !labels.includes('Current Year'))
      return ['Current Year'];
    else if (
      currentDate > end_date &&
      (currentDate - end_date) / (1000 * 3600 * 24) < 366 &&
      !labels.includes('Last Year')
    )
      return ['Last Year'];

    return [startDate, endDate];
  };

  getContentdatestr = (str) => {
    let contentdatestr = '',
      color = '';
    if (str === 'Current Year') {
      contentdatestr = 'current contract year';
      color = '#5A8BED';
    } else if (str === 'Last Year') {
      contentdatestr = 'previous contract year';
      color = '#C7CDE0';
    } else {
      contentdatestr = str;
      color = '#C7CDE0';
    }

    return [contentdatestr, color];
  };

  getOverallData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overall.length;
    this.overall.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');
      labels.push(str);
      data.push(item.consultations);
      if (max < item.consultations) max = item.consultations;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);
      var contract = this.contracts.filter((contract) => (contract.start_date === item.start_date && contract.end_date === item.end_date))
      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700 '>
            {item.consultations
              ? `${commaingNumber(item.consultations)} (${Math.round((item.consultations / contract[0].total_customers) * 100)}%)`
              : 'No'}{' '}
            consultation
          </span>{' '}
          taken in {['Current Year', 'Previous Year'].includes(str) ? 'the' : 'between'}&nbsp;{' '}
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };

  getOverallAvgWaitTimeData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallAvgWaitTime.length;
    this.overallAvgWaitTime.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');
      labels.push(str);

      data.push(item.time);
      if (max < item.time) max = item.time;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700'>
            {item.time ? `${commaingNumber(item.time)} seconds` : 'No'} average wait time:
          </span>{' '}
          for doctor consultation in {['Current Year', 'Previous Year'].includes(str) ? 'the' : 'between'}
          &nbsp;
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };

  getOverallRatingsData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallRatings.length;
    this.overallRatings.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');
      labels.push(str);

      data.push(item.total_ratings);
      if (max < item.total_ratings) max = item.total_ratings;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div
          className={
            `text-lg text-gray-600 flex` + (index === length - 1 ? '' : ' mb-4') + (item.total_ratings ? ' ml-9' : ' ml-14')
          }
        >
          {item.total_ratings && (
            <img src={FullStar} className='mr-2 mb-8 mt-1' style={{ width: '15px', height: '15px' }} alt='star' />
          )}
          <span>
            <span className='font-semibold text-gray-700'>{item.total_ratings || 'No'}&nbsp; doctor consultation</span> rating
            given by your employees in {['Current Year', 'Previous Year'].includes(str) ? 'the' : 'between'}&nbsp;{' '}
            <span className='font-semibold text-gray-700'>{contentdatestr}</span>
          </span>
        </div>
      );
    });

    return {
      labels,
      data,
      barColors,
      content,
      max,
    };
  };

  getOverallRepeatUsersData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallRepeatUsers.length;
    this.overallRepeatUsers.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');
      labels.push(str);

      data.push(item.users);
      if (max < item.users) max = item.users;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700'>
            {item.users ? commaingNumber(item.users) : 'No'}&nbsp;users
          </span>{' '}
          took doctor consultation multiple times in{' '}
          {['Current Year', 'Previous Year'].includes(str) ? 'the' : 'between'}&nbsp;{' '}
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };
}

export default OverallManager;
